import gql from 'graphql-tag';

export const CREATE_STALL_PRODUCT_DISCOUNT = gql`
  mutation CreateStallProductDiscount($input: ProductDiscountInput!) {
    createStallProductDiscount(input: $input) {
      productDiscount {
        id
        xProductId
        xRefTypeId
        startDate
        endDate
        rate
        maxQuantity
        createdAt
        updatedAt
      }
      error
    }
  }
`;
